import React from 'react';
import {connect} from 'react-redux';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {Alert} from 'componentLibrary';
import ApiActions from 'go/actions/api';
import moment from 'moment-timezone';

export class ConcurrentEditingWrapper extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {isConcurrencyModalActive, modifiedBy, modifyDate} = this.props;
    const content =
      'A new version exists. This version was created by ' +
      (modifiedBy !== undefined ? modifiedBy : 'another user') +
      ' at ' +
      moment(modifyDate).local().toDate() +
      ". By clicking 'Ok', the page will refresh to the latest version. Your last edit will not be saved.";
    let modal = (
      <FemaGoModal
        title="A new version exists!"
        size="small"
        hideCancel={true}
        open={isConcurrencyModalActive ? isConcurrencyModalActive : false}
        buttonText="OK"
        type="alert"
        cancelAction={() => window.location.reload()}
        confirmAction={() => window.location.reload()}
      >
        <Alert
          size="medium"
          header=""
          content={content}
          type="error"
          dismissable={false}
        />
      </FemaGoModal>
    );
    return modal;
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    getUser: (userId, jwt) => {
      const action = ApiActions.profile.getUser(userId, jwt);
      const response = dispatch(action);
      return response;
    },
  };
};

export const mapStateToProps = (state) => {
  return {
    isConcurrencyModalActive: state.dynamicComponent.isConcurrencyModalActive,
    modifiedBy: state.dynamicComponent.modifiedBy,
    modifyDate: state.dynamicComponent.modifyDate,
    jwt: state.auth.token,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null
)(ConcurrentEditingWrapper);
